class Storage {
  constructor(props) {
    this.props = props || {};
    this.source = window.localStorage;
    this.initRun();
  }
  initRun() {
    /*
     * 清除已经过期的数据
     */
    try {
      const reg = new RegExp('__expires__');
      let source = this.source;
      let list = Object.keys(source);
      if (list.length > 0) {
        list.map((key) => {
          if (!reg.test(key)) {
            let now = Date.now();
            let expires = source[`${key}__expires__`] || Date.now() + 1;
            if (now >= expires) {
              this.remove(key);
            }
          }
          return key;
        });
      }
    } catch (err) {
      alert('initRun');
      alert(JSON.stringify(err));
    }
  }
  set(key, value, expired) {
    /*
     * set 存储方法
     * @ param {String}     key 键
     * @ param {String}     value 值，
     * @ param {String}     expired 过期时间，以天为单位，非必须
     */
    try {
      let source = this.source;
      source[key] = value;
      if (expired) {
        source[`${key}__expires__`] = Date.now() + 1000 * 60 * 60 * 24 * expired;
      }
      return value;
    } catch (err) {
      alert('set');
      alert(JSON.stringify(err));
    }
  }
  get(key) {
    /*
     * get 获取方法
     * @ param {String}     key 键
     * @ param {String}     expired 存储时为非必须字段，所以有可能取不到，默认为 Date.now+1
     */
    try {
      const source = this.source;
      const expired = source[`${key}__expires__`] || Date.now() + 1;
      const now = Date.now();

      if (now >= expired) {
        this.remove(key);
        return;
      }
      const value = source[key];
      return value;
    } catch (err) {
      alert('get');
      alert(JSON.stringify(err));
    }
  }
  remove(key) {
    try {
      const source = this.source;
      const value = source[key];
      delete source[key];
      delete source[`${key}__expires__`];
      return value;
    } catch (err) {
      alert('remove');
      alert(JSON.stringify(err));
    }
  }
}

export default new Storage();
